export const currencySymbols: Record<string, string> = {
  // Arab currencies (non-Latin symbols replaced)
  AED: "AED",
  BHD: "BHD",
  DZD: "DZD",
  EGP: "£",
  IQD: "IQD",
  JOD: "JOD",
  KWD: "KWD",
  LBP: "LBP",
  LYD: "LYD",
  MAD: "MAD",
  OMR: "OMR",
  QAR: "QAR",
  SAR: "SAR",
  SDG: "SDG",
  SYP: "£",
  TND: "TND",
  YER: "YER",

  // Asia
  AFN: "AFN",
  AMD: "֏",
  AZN: "₼",
  BDT: "৳",
  BTN: "Nu.",
  BND: "$",
  CNY: "¥",
  GEL: "₾",
  HKD: "$",
  INR: "₹",
  IDR: "Rp",
  IRR: "IRR",
  ILS: "₪",
  JPY: "¥",
  KZT: "₸",
  KRW: "₩",
  KGS: "KGS",
  LAK: "₭",
  MYR: "RM",
  MNT: "₮",
  MMK: "K",
  NPR: "₨",
  PKR: "₨",
  PHP: "₱",
  SGD: "$",
  LKR: "Rs",
  TWD: "NT$",
  THB: "฿",
  TRY: "₺",
  TJS: "TJS",
  TMT: "TMT",
  UZS: "UZS",
  VND: "₫",

  // Europe
  EUR: "€",
  GBP: "£",
  CHF: "CHF",
  RON: "lei",
  RUB: "₽",
  PLN: "zł",
  HUF: "Ft",
  CZK: "Kč",
  DKK: "kr",
  SEK: "kr",
  NOK: "kr",
  ISK: "kr",
  BYN: "Br",
  MKD: "MKD",
  RSD: "дин",
  UAH: "₴",
  BGN: "лв",
  BAM: "KM",
  ALL: "L",
  MDL: "L",
  HRK: "€",

  // Americas
  USD: "$",
  CAD: "$",
  AUD: "$",
  MXN: "$",
  ARS: "$",
  BRL: "R$",
  CLP: "$",
  COP: "$",
  CRC: "₡",
  PEN: "S/",
  UYU: "$U",
  PAB: "B/.",
  DOP: "RD$",
  BBD: "$",
  BOB: "Bs.",
  BSD: "$",
  CUP: "$",
  GTQ: "Q",
  HNL: "L",
  HTG: "G",
  JMD: "J$",
  NIO: "C$",
  TTD: "TT$",
  VES: "Bs.S",
  PYB: "₲",
};
